import EnhancedTableRow from './EnhancedTableRow';

export default EnhancedTableRow;
